// Y9 services + portfolio showcase data
export const FEATURED = {
  id: "e-cards",
  title: "الكروت الإلكترونية",
  desc: "ما يميّز زخرف — كروت دعوات إلكترونية تفاعلية وأنيقة تصل ضيوفك بضغطة زر عبر الجوال، بتصميم يعكس فخامة مناسبتك.",
  points: ["تصميم مخصّص بالكامل", "تُفتح على كل الأجهزة", "سهلة المشاركة عبر الواتساب"],
};

export const SERVICES = [
  {
    id: "wedding",
    title: "دعوات الأعراس",
    desc: "دعوات زفاف فاخرة بخطوط عربية أنيقة وتفاصيل تليق بأجمل ليالي العمر.",
  },
  {
    id: "graduation",
    title: "حفلات التخرّج",
    desc: "تصاميم مبهجة تحتفي بالإنجاز، بألوان راقية وهوية خاصة بمناسبتك.",
  },
  {
    id: "corporate",
    title: "المناسبات الرسمية",
    desc: "دعوات المؤتمرات والفعاليات الرسمية بطابع احترافي وأنيق.",
  },
  {
    id: "occasions",
    title: "المناسبات الخاصة",
    desc: "مآدب ولقاءات وحفلات مميزة — كل مناسبة تستحق دعوة تليق بها.",
  },
];

export const PORTFOLIO = [
  { id: "p1", title: "سويت الزفاف الكامل", cat: "زفاف", img: "https://images.unsplash.com/photo-1732649124686-3bab54f79aa3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: "p2", title: "دعوة على الحرير", cat: "خطوبة", img: "https://images.unsplash.com/photo-1741893043659-ca8b82a8b637?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: "p3", title: "الأبيض والأسود", cat: "رسمي", img: "https://images.unsplash.com/photo-1632610992723-82d7c212f6d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: "p4", title: "شرائط داكنة", cat: "زفاف", img: "https://images.pexels.com/photos/37460539/pexels-photo-37460539.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900" },
  { id: "p5", title: "الصينية الذهبية", cat: "مناسبات", img: "https://images.pexels.com/photos/4554087/pexels-photo-4554087.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900" },
  { id: "p6", title: "خط عربي وتقويم", cat: "خطوبة", img: "https://images.unsplash.com/photo-1744488872457-045ad5af15bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const HERO_IMG = "https://images.pexels.com/photos/18748937/pexels-photo-18748937.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1100";
export const ABOUT_IMG = "https://images.unsplash.com/photo-1764380746366-f4d8cc52e1e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100";
